// src/utils/confetti.ts
import confetti from "canvas-confetti";

export function fireConfetti() {
  const mode = Math.random() < 0.5 ? "burst" : "rain";

  if (mode === "burst") {
    // 🎆 Quick pop burst
    confetti({
      particleCount: 120,
      spread: 70,
      origin: { y: 0.6 },
      scalar: 1.6,      // a bit larger pieces
      ticks: 90         // ~1.5s lifespan
    });
  } else {
    // 🌧 Rainfall from top
    confetti({
      particleCount: 200,
      spread: 120,
      origin: { x: 0.5, y: 0 },
      startVelocity: 30,
      gravity: 1.2,     // heavier fall
      scalar: 1.2,
      ticks: 300        // ~5s lifespan
    });
  }
}


// 👇 add this line to satisfy TS `--isolatedModules`
export {};
